import React from 'react';
import block from 'bem-cn-lite';
import {Text} from '@gravity-ui/uikit';

import './NdsInfo.scss';

const b = block('nds-info');

interface NdsInfoProps {
    nds: boolean;
    className?: string;
}

export const NdsInfo: React.FC<NdsInfoProps> = ({nds, className}) => {
    return (
        <div className={`${b('block', className)}`}>
            {nds && <Text variant="body-1">без НДС</Text>}
        </div>
    );
};
